<template>
  <div class="meeting">
    <advertising-figure :bannerSrc="bannerSrc"/>
    <div class="inner-page-nav">
      <inner-page-nav />
    </div>
    <div class="inner-page-content">
      <public-title :title="title">
        <span class="sub">Agenda of the meeting</span>
      </public-title>
      <div class="agenda-image inline">
        <RichHtml :content="content"></RichHtml>
      </div>
    </div>
  </div>
</template>

<script>
  import AdvertisingFigure from "@components/advertising"
  import InnerPageNav from "@components/tool-nav"
  import PublicTitle from "@components/title"
  import CurrentConferMixin from "@/mixin/CurrentConference"
  import RichHtml from "@/components/RichHtml"

  export default {
    name: "MeetingDetails",
    components: {
      PublicTitle,
      AdvertisingFigure,
      InnerPageNav,
      RichHtml
    },
    mixins: [CurrentConferMixin],
    data() {
      return {
        bannerSrc:require("@assets/img/meeting-banner.png"),
        title: "会议日程",
        content: "",
      }
    },
    async mounted() {
      await this.$store.dispatch("conference/getCurrentConference")
      const schedule = this.currentConference.schedules.find(
        (x) => x.device == "电脑"
      )
      this.content = schedule.introduction
    },
    methods: {
      jumpTo(item) {
        this.$router.push({
          name: "scheduleDetailPage",
          params: { schedule: item },
        })
      },
      getInfo() {
        // console.log(this.$route.params)
      },
    },
    watch: {
      $route: "getInfo",
    },
  }
</script>

<style lang="scss" scoped>
  @import "@assets/scss/innerpagenav.scss";
  .agenda-image {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .agenda-image img {
    /*这个宽度自己调整就可以*/
    width: 50%;
  }
  .inner-page-nav {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 0 15px;
    margin: 0 auto;
  }

  .inner-page-content {
    margin: 60px 0;
  }

  .list {
    @include flex-between;
    width: 1200px;
    height: 50px;
    padding: 0 15px;
    margin: 30px auto;
    border-bottom: 1px solid #eee;

    .high {
      height: 100%;

      span {
        font-size: 12px;
        text-align: center;
        color: $defaultColor;
        cursor: pointer;
      }
    }

    .tit {
      position: relative;
      font-size: 18px;
      color: #666;
      font-weight: normal;
      margin-bottom: 5px;
    }

    .time {
      font-size: 14px;
      color: #999;
    }
  }
</style>
